// index.tsx
import React from 'react';
import { createRoot } from "react-dom/client";
import App from './App';
import { BrowserRouter } from "react-router-dom";
import { CssBaseline, ThemeProvider, createTheme, StyledEngineProvider, } from "@mui/material";
import { MuiTheme, GlobalStyle } from './ui/global/GlobalStyles';
import { HelmetProvider } from 'react-helmet-async';
import posthog from './utils/analytics';
import { PostHogProvider} from 'posthog-js/react'

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
    <HelmetProvider>
      <PostHogProvider client={posthog}>
        <BrowserRouter>
          <StyledEngineProvider injectFirst>
            <ThemeProvider theme={MuiTheme}>
              <CssBaseline />
              <App />
            </ThemeProvider>
          </StyledEngineProvider>
        </BrowserRouter>
      </PostHogProvider>
    </HelmetProvider>
);
